const WorkerStatusEnum = {
    0: "Bekliyor",
    1: "Çalışıyor",
    2: "Durdu",
};

export default WorkerStatusEnum;